/* eslint-disable quote-props */
import clx from "classnames";

export enum Tags {
    "h1" = "h1",
    "h2" = "h2",
    "h3" = "h3",
    "h4" = "h4",
    "h5" = "h5",
    "h6" = "h6",
    "p" = "p",
    "a" = "a",
    "span" = "span",
    "strong" = "strong",
    "address" = "address",
    "div" = "div",
    "dt" = "dt",
    "dd" = "dd",
    "legend" = "legend",
}

export const Colors = {
    default: "text-default",
    mint: "text-mint-500",
    midnight: "text-midnight-500",
    pine: "text-pine-600",
    white: "text-white",
    plum: "text-plum-500",
};

export const Variants = {
    subTitle: "type-sub-title",
    heading: "type-heading",
    subHeading: "type-sub-heading",
    figure: "type-figure",
    emphasis: "type-emphasis",
    paragraph: "type-paragraph",
    inlineLink: "type-inline-link",
    meta: "type-meta",
    label: "type-label",
    smallCaps: "type-small-caps",
    note: "type-note",
};

export const Accents = {
    underline: "underline",
    bold: "!font-bold",
};

export const FontSizes = {
    "070": "text-070",
    "080": "text-080",
    "090": "text-090",
    "100": "text-100",
    "200": "text-200",
    "300": "text-300",
    "400": "text-400",
    "500": "text-500",
    "600": "text-600",
    "700": "text-700",
    "800": "text-800",

    // '070-fluid': 'text-070-fluid',
    // '080-fluid': 'text-080-fluid',
    // '090-fluid': 'text-090-fluid',
    // '100-fluid': 'text-100-fluid',
    // '200-fluid': 'text-200-fluid',
    // '300-fluid': 'text-300-fluid',
    // '400-fluid': 'text-400-fluid',
    // '500-fluid': 'text-500-fluid',
    // '600-fluid': 'text-600-fluid',
    // '700-fluid': 'text-700-fluid',
    // '800-fluid': 'text-800-fluid',
};

export interface UseTypographyOptions {
    as?: Tags | keyof typeof Tags;
    variant?: keyof typeof Variants;
    color?: keyof typeof Colors;
    accent?: keyof typeof Accents;
    fontSize?: keyof typeof FontSizes;

    className?: string; // Use this sparingly or for layout purposes. Or you will die. Use the variant and color props instead plz.
}

const useTypography = ({ variant, color, className = "", fontSize, accent }: UseTypographyOptions) => {
    const cn = clx(
        variant ? Variants[variant] : "",
        color ? Colors[color] : "",
        accent ? Accents[accent] : "",

        fontSize ? FontSizes[fontSize] : "",
        className
    );

    return cn;
};

export default useTypography;
